var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"scroll-nav"},[_c('button',{staticClass:"scroll-nav__btn scroll-nav__btn--prev",on:{"click":function($event){return _vm.$emit('prev')}}},[_vm._v(" ▲ ")]),_c('button',{staticClass:"scroll-nav__btn scroll-nav__btn--next",on:{"click":function($event){return _vm.$emit('next')}}},[_vm._v(" ▼ ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }